<template>
    <base-modal
        :modal-name="modalNames.addPack"
        title="Choisissez les catégories de votre pack"
        @confirm-action="$root.savePack(categories, packIdentifier)"
    >
        <template>
            <div v-if="$parent.packIdentifiersAvailable.length === 1">Pack {{ packIdentifier }}</div>
            <div
                v-else
                class="my-3"
            >
                <base-select
                    id="pack-identifier"
                    v-model="packIdentifier"
                    @change.native="resetCategories()"
                >
                    <option
                        v-for="(identifier, index) of $parent.packIdentifiersAvailable"
                        :key="index"
                        :value="identifier"
                    >
                        Pack #{{ $parent.packIdentifierIndex(identifier) }}
                    </option>
                </base-select>
            </div>

            <div
                v-for="(category, index) in categories"
                :key="index"
            >
                <div>Appareil #{{ index + 1 }}</div>
                <ChooseCategory
                    :categories="currentPackCategories[index]"
                    :category="category"
                    :index="index"
                    size="sm"
                    @update-category="updateCategory"
                />
            </div>
        </template>
        <template #validate>
            <base-button
                :disabled="isSavePackDisabled"
                icon="check"
            >
                Enregistrer
            </base-button>
        </template>
    </base-modal>
</template>

<script>
import { mapWritableState } from 'pinia'

import useGenericStore from '../../common/store/generic'
import ChooseCategory from '../../components/ChooseCategory'

export default {
  name: 'TheAddPackModal',
  components: { ChooseCategory },
  data () {
    return {
      packIdentifier: null,
      categories: []
    }
  },

  computed: {
    ...mapWritableState(useGenericStore, ['modalNames']),

    packCategories () {
      return this.$parent.chosenOffer.devices_packs.reduce((acc, pack) => {
        acc[pack.identifier] = pack.content
        return acc
      }, {})
    },

    currentPackCategories () {
      return this.packCategories[this.packIdentifier]
        .map(categories => categories.map(category => category.category))
    },

    isSavePackDisabled () {
      return this.categories.every(category => category === null)
    }
  },

  created () {
    this.packIdentifier = this.$parent.packIdentifiersAvailable[0]
    this.resetCategories()
  },

  methods: {
    updateCategory (value, index) {
      this.$set(this.categories, index, value)
    },

    resetCategories () {
      this.categories = this.currentPackCategories.map(_ => null)
    }
  }
}
</script>

<style scoped>

</style>
